import React, { useState } from 'react';
import styles from './VersionInfo.module.css';

function VersionInfo() {
    const [isExpanded, setIsExpanded] = useState(false);
    const version = process.env.REACT_APP_VERSION || require('../../../package.json').version;
    const buildDate = process.env.REACT_APP_BUILD_DATE || new Date().toISOString();
    const commitHash = process.env.REACT_APP_COMMIT_HASH || 'dev';

    return (
        <div className={styles['version-container']}>
            <button 
                className={styles['version-badge']}
                onClick={() => setIsExpanded(!isExpanded)}
                aria-label="Toggle version information"
                title="Click to see more details"
            >
                v{version}
            </button>
            {isExpanded && (
                <div className={styles['version-details']}>
                    <div className={styles['detail-row']}>
                        <span className={styles['label']}>Version:</span>
                        <span className={styles['value']}>{version}</span>
                    </div>
                    <div className={styles['detail-row']}>
                        <span className={styles['label']}>Build Date:</span>
                        <span className={styles['value']}>
                            {new Date(buildDate).toLocaleString()}
                        </span>
                    </div>
                    <div className={styles['detail-row']}>
                        <span className={styles['label']}>Commit:</span>
                        <span className={styles['value']}>{commitHash.substring(0, 7)}</span>
                    </div>
                </div>
            )}
        </div>
    );
}

export default VersionInfo;
